// Enhanced Color interface that includes contrast colors for better accessibility
export interface Color {
  100: string;
  200: string;
  300: string;
  400: string;
  500: string;
  600: string;
  700: string;
  800: string;
  900: string;
  1000: string;
}

export interface EnhancedColor {
  50?: string;  // Added for MUI compatibility
  100: string;
  200: string;
  300: string;
  400: string;
  500: string;
  600: string;
  700: string;
  800: string;
  900: string;
  1000?: string;
  A100?: string;
  A200?: string;
  A400?: string;
  A700?: string;
}

// Your existing color definitions with MUI-compatible enhancements
export const primaryGreen: EnhancedColor = {
  50: "#E8F5F0",   // Added lighter shade for MUI
  100: "#D2F0E6",
  200: "#B6E9D6",
  300: "#9BE2C6",
  400: "#7FDBB6",
  500: "#6FD3A6",  // Main color
  600: "#54CC96",
  700: "#4AC08C",
  800: "#2EB273",
  900: "#279769",
  1000: "#1F7C5E",
  A100: "#B6E9D6",
  A200: "#7FDBB6",
  A400: "#4AC08C",
  A700: "#279769",
};

export const green: EnhancedColor = {
  50: "#F0FCF4",
  100: "#DDF9E4",
  200: "#D0F0DA",
  300: "#C3E6CF",
  400: "#B6DCC5",
  500: "#A8D2BA",
  600: "#72AA8F",
  700: "#58967A",
  800: "#3D8264",
  900: "#226E4F",
  1000: "#075A39",
};

export const lightGreen: EnhancedColor = {
  50: "#FAFDF2",
  100: "#F4FBCB",
  200: "#EAF2BF",
  300: "#E0E8B3",
  400: "#D6DEA7",
  500: "#CBD49A",
  600: "#A2AD69",
  700: "#98A45D",
  800: "#8E9A51",
  900: "#798638",
  1000: "#505F07",
};

export const olive: EnhancedColor = {
  50: "#FFFAF0",
  100: "#FFF3CC",
  200: "#F7EAC0",
  300: "#EEE0B3",
  400: "#E5D6A6",
  500: "#DCCC99",
  600: "#B8A466",
  700: "#A6914D",
  800: "#947D33",
  900: "#82691A",
  1000: "#705500",
};

export const magenta: EnhancedColor = {
  50: "#FFF8FA",
  100: "#FEECF1",
  200: "#F6DEE8",
  300: "#EDD0DF",
  400: "#E4C2D6",
  500: "#DBB3CC",
  600: "#B779A7",
  700: "#AE6B9E",
  800: "#A55D95",
  900: "#934082",
  1000: "#6F065D",
};

export const blue: EnhancedColor = {
  50: "#F0FAFD",
  100: "#DAF4FC",
  200: "#CDEBF4",
  300: "#C0E1EB",
  400: "#B3D8E2",
  500: "#A6CED9",
  600: "#72A7B6",
  700: "#5894A5",
  800: "#3E8193",
  900: "#246E82",
  1000: "#0A5A70",
};

export const neutral: EnhancedColor = {
  50: "#FEFEFE",
  100: "#FBFBFB",
  200: "#EEEFF1",
  300: "#D3D3D4",
  400: "#BDBEBF",
  500: "#A7A8A9",
  600: "#919294",
  700: "#7B7C7F",
  800: "#656669",
  900: "#232529",
  1000: "#1F2125",
};

export const red: EnhancedColor = {
  50: "#FFF5F5",
  100: "#FFEBEB",
  200: "#EED2D2",
  300: "#DDB9B9",
  400: "#D5ADAD",
  500: "#CCA0A0",
  600: "#BB8787",
  700: "#AA6E6E",
  800: "#995555",
  900: "#883C3C",
  1000: "#772322",
};

export const error: EnhancedColor = {
  50: "#FEF7F7",
  100: "#FEDFDF",
  200: "#FCBFBF",
  300: "#FBA0A0",
  400: "#F98080",
  500: "#F86060",
  600: "#C64D4D",
  700: "#953A3A",
  800: "#632626",
  900: "#321313",
  1000: "#250E0E",
};